import React from 'react';
import PropTypes from 'prop-types';
import { Success } from '../../../Elements';
import { Button } from 'semantic-ui-react';

const EmailSuccess = ({ onClose, to, cc }) => (
  <div style={{ textAlign: 'center' }}>
    <Success />
    <h3>Contract Sent!</h3>
    <p style={{ marginBottom: '2em' }}>
      Your contract was sent to <strong>{to}</strong>.
      {cc && <span> and CC'd to <strong>{cc}</strong></span>}.
    </p>
    <Button basic fluid content='Done' onClick={onClose} />
  </div>
);

EmailSuccess.propTypes = {
  onClose: PropTypes.func.isRequired,
  to: PropTypes.string.isRequired,
  cc: PropTypes.string
};

export default EmailSuccess;



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/Share/EmailSuccess.js